export const getTableColumns = (t) => [
  { title: t('columns.time'), prop: 'displayTime', fixed: true, width: '230px' },
  { title: t('columns.instrument'), prop: 'displayName', fixed: true, width: '130px', align: 'right' },
  { title: t('columns.type'), prop: 'type', align: 'right' },
  { title: t('columns.side'), prop: 'side', align: 'right' },
  { title: t('columns.price'), prop: 'price', align: 'right' },
  { title: t('columns.quantity'), prop: 'size', align: 'right' },
  { title: t('perpetual.orderValue'), prop: 'orderValue', align: 'right' },
  { title: t('columns.triggerCondition'), prop: 'triggerCondition', align: 'right' },
  { title: t('columns.orderID'), prop: 'id', align: 'right' },
  { title: t('columns.action'), prop: 'action', fixed: true, width: '100px', align: 'center' },
]

export const getCellColumns = (t) => [
  { title: t('columns.time'), prop: 'displayTime' },
  { title: t('columns.triggerCondition'), prop: 'triggerCondition', valueSlot: 'triggerCondition' },
  // TODO: add translation
  { title: 'OCO ID', prop: 'listId', valueSlot: 'listId', filter: val => !!val },
  { title: t('columns.orderID'), prop: 'id', valueSlot: 'orderId' },
]
